import { useEffect, useRef, useState } from 'react';

const useFormInitialValues = (resource, defaultValues = {}) => {
  const initializedRef = useRef(false);
  const [initialValues, setInitialValues] = useState(defaultValues);

  useEffect(() => {
    if (!initializedRef.current && resource) {
      setInitialValues(resource);
      initializedRef.current = true;
    }
  }, [resource]);

  useEffect(() => {
    return () => {
      initializedRef.current = false;
    };
  }, []);

  return initialValues;
};

export default useFormInitialValues;
